import SingularImagingSolutionsLanding from "@/components/SingularImagingLanding";

const Index = () => {
  return <SingularImagingSolutionsLanding />;
};

export default Index;
